import { useState, useEffect } from 'react'

interface TimeLeft {
  hours: number
  minutes: number
  seconds: number
}

export function useCountdown(
  initialHours: number,
  initialMinutes: number,
  initialSeconds: number,
) {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds,
  })

  useEffect(() => {
    const STORAGE_KEY = 'pausa_countdown_end_time'
    let endTime = localStorage.getItem(STORAGE_KEY)

    if (!endTime) {
      const totalMs =
        (initialHours * 60 * 60 + initialMinutes * 60 + initialSeconds) * 1000
      endTime = (Date.now() + totalMs).toString()
      localStorage.setItem(STORAGE_KEY, endTime)
    }

    const calculateTimeLeft = () => {
      const difference = parseInt(endTime!) - Date.now()

      if (difference > 0) {
        return {
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        }
      }

      return { hours: 0, minutes: 0, seconds: 0 }
    }

    setTimeLeft(calculateTimeLeft())

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)

    return () => clearInterval(timer)
  }, [initialHours, initialMinutes, initialSeconds])

  return timeLeft
}
